module.exports = __webpack_public_path__ + "static/media/appleFruit.6b0610d7.svg";